import {
  GetNotificationsDocument,
  NotificationFragmentDoc,
  UpdateNotificationFragmentDoc,
} from "~/schemas/generated/graphql";

export const resolvers = {
  Mutation: {
    addNotification: (_, variables, { cache }) => {
      const query = GetNotificationsDocument;
      const previous = cache.readQuery({ query });

      const newNotification = {
        id: variables.id || Date.now() / 2,
        isOpen: true,
        type: variables.type,
        status: variables.status || null,
        content: variables.content || null,
        label: variables.label || null,
        duration: variables.duration ?? null,
        __typename: "Notification",
      };

      cache.writeQuery({
        query,
        data: {
          getNotifications: [newNotification, ...previous.getNotifications],
        },
      });

      return newNotification;
    },
    updateNotification: (_root, variables, { cache, getCacheKey }) => {
      const id = getCacheKey({
        __typename: "Notification",
        id: variables.id,
      });

      const notification = cache.readFragment({
        fragment: UpdateNotificationFragmentDoc,
        id,
      });

      cache.writeData({
        id,
        data: {
          id: variables.id,
          isOpen:
            variables.isOpen === undefined
              ? notification.isOpen
              : variables.isOpen,
          type: variables.type || notification.type,
          status:
            notification.content && notification.label
              ? notification.status
              : variables.status,
          content: variables.content || notification.content,
          label: variables.label || notification.label,
          duration:
            variables.duration === undefined
              ? notification.duration
              : variables.duration,
          __typename: "Notification",
        },
      });

      return cache.readFragment({
        fragment: NotificationFragmentDoc,
        id,
      });
    },
  },
};
